"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
// actually fork from prosemirror-inputrules
var prosemirror_state_1 = require("prosemirror-state");
var MAX_MATCH = 500;
var SHORTCUT_KEY = new prosemirror_state_1.PluginKey('textShortcut');
exports.SHORTCUT_KEY = SHORTCUT_KEY;
// 找出insertText和match重叠部分的长度
var sameStart = function (textBefore, match) {
    for (var i = textBefore.length; i >= 0; i--) {
        if (textBefore[i] === match[0]) {
            // textBefore `012` match `12`，此时结果为2
            var compareText = textBefore.substr(i, match.length);
            if (compareText === match)
                return i;
        }
    }
    return 0;
};
var stringHandler = function (string) { return function (view, state, match, start, end) {
    var insert = string;
    if (match[1]) {
        var realStart = start;
        var offset = match[0].lastIndexOf(match[1]);
        insert += match[0].slice(offset + match[1].length);
        realStart += offset;
        var cutOff = start - end;
        if (cutOff > 0) {
            insert = match[0].slice(offset - cutOff, offset) + insert;
            realStart = end;
        }
    }
    return state.tr.insertText(insert, start, end);
}; };
var TextShortcut = /** @class */ (function () {
    function TextShortcut(name, matcher, handler, config) {
        this.name = name;
        this.matcher = matcher;
        this.handler = typeof handler === 'string' ? stringHandler(handler) : handler;
        this.config = config;
        if (!this.config.timing)
            this.config.timing = 'input';
    }
    return TextShortcut;
}());
exports.TextShortcut = TextShortcut;
var TextShortcutPlugin = /** @class */ (function (_super) {
    __extends(TextShortcutPlugin, _super);
    function TextShortcutPlugin(textShortcuts) {
        var _this = _super.call(this, {
            key: SHORTCUT_KEY,
            state: {
                init: function () {
                    return null;
                },
                apply: function (tr, state) {
                    var stored = tr.getMeta(SHORTCUT_KEY);
                    if (typeof stored === 'boolean')
                        _this.enable = stored;
                    if (stored)
                        return stored;
                    return tr.selectionSet || tr.docChanged ? null : state;
                }
            },
            props: {
                handleTextInput: function (view, from, to, text) {
                    if (!_this.enable)
                        return false;
                    return _this.applyTextShortcuts(view, from, to, text);
                },
                handleKeyDown: function (view, event) {
                    if (!_this.enable)
                        return false;
                    if ((event.key === 'Enter' && event.keyCode === 13) || event.which === 13) {
                        return _this.applyEnterShortcuts(view);
                    }
                    return false;
                }
            }
        }) || this;
        _this.enable = true;
        _this.applyEnterShortcuts = function (view) {
            var _a = view.state.selection, to = _a.to, from = _a.from, nodeBefore = _a.$from.nodeBefore;
            if (nodeBefore && nodeBefore.isText) {
                return _this.applyTextShortcuts(view, from, to, '', 'enter');
            }
            return false;
        };
        _this.applyTextShortcuts = function (view, from, to, insertText, timing) {
            if (timing === void 0) { timing = 'input'; }
            var state = view.state;
            var $from = state.doc.resolve(from);
            // this should remind not emit in code_block or code or any
            // using text as content structure
            if ($from.parent.type.spec.code === true) {
                return false;
            }
            var textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - MAX_MATCH), $from.parentOffset, undefined, '\uFFFC') +
                insertText;
            for (var _i = 0, _a = _this.textShortcuts; _i < _a.length; _i++) {
                var textShortcut = _a[_i];
                if (textShortcut.config.timing !== timing)
                    continue;
                var match = textShortcut.matcher.exec(textBefore);
                var tr = null;
                if (match !== null) {
                    var realFrom = from + insertText.length - textBefore.length + sameStart(textBefore, match[0]);
                    tr = textShortcut.handler(view, state, match, realFrom, Math.min(to, realFrom + match[0].length), insertText);
                }
                if (tr) {
                    tr.setMeta(SHORTCUT_KEY, {
                        name: textShortcut.config.name || textShortcut.name,
                        transform: tr,
                        from: from,
                        to: to,
                        text: insertText
                    });
                    view.dispatch(tr);
                    return true;
                }
            }
            return false;
        };
        _this.textShortcuts = textShortcuts;
        return _this;
    }
    return TextShortcutPlugin;
}(prosemirror_state_1.Plugin));
exports.TextShortcutPlugin = TextShortcutPlugin;
// This is a command that will undo a text shortcut, if applying such a rule was
// the last thing that the user did.
var undoTextShortcut = function (state, dispatch) {
    var undoAble = SHORTCUT_KEY.getState(state);
    if (undoAble && typeof undoAble !== 'boolean' && dispatch) {
        var tr = state.tr;
        var toUndo = undoAble.transform;
        for (var j = toUndo.steps.length - 1; j >= 0; j--) {
            tr.step(toUndo.steps[j].invert(toUndo.docs[j]));
        }
        var marks = tr.doc.resolve(undoAble.from).marks();
        dispatch(tr.replaceWith(undoAble.from, undoAble.to, undoAble.text ? state.schema.text(undoAble.text, marks) : undefined));
        return true;
    }
    return false;
};
exports.undoTextShortcut = undoTextShortcut;
var getShortcutAttrs = function (getAttrs, view, match, start, end) {
    if (!getAttrs)
        return {};
    if (getAttrs instanceof Function) {
        var res = getAttrs(match, start, {
            getStart: function () { return view.coordsAtPos(start); },
            getEnd: function () { return view.coordsAtPos(end); }
        });
        if (res === true)
            return {};
        return res;
    }
    return getAttrs;
};
exports.getShortcutAttrs = getShortcutAttrs;
//# sourceMappingURL=shortcut-plugin.js.map